import * as React from "react";
import {Link} from "react-router-dom";

import "./empty-listing.scss";

export const EmptyListings = () => (
    <div className="empty-listing-e7y">
        <div className="info">What is My Listings?</div>
        <div className="desc">
            With My Listings we give you direct access to your just listed
            and just sold properties by consolidating them into one dashboard.
            Using property feeds, we have pulled in your property details including number of
            photos, addresses, listed dates and sold dates.
        </div>
        <div className="no-listings">There are no Listings created yet</div>
        <Link to={"/"}>
            <button className="to-home" xd-qa-type="button" xd-qa-name="Back to the Home Page">Back to the Home Page</button>
        </Link>
    </div>

);